import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import style from './menu-top-item.scss';

/**
 * Item for top menu.
 */
@customElement('menu-top-item')
export class MenuTopItem extends LitElement {
    static override styles = style;

    /**
     * Target URL. Can be ommited for greyed item.
     */
    @property() href = '';

    /**
     * Item name.
     */
    @property() name = '';

    /**
     * Should this item be greyed as inactive item?
     */
    @property({ type: Boolean, reflect: true }) greyed = false;

    constructor() {
        super();
        const internals = this.attachInternals();
        internals.role = 'listitem';
    }

    override render() {
        return html`
            <span><a href=${this.href}>${this.name}</a></span>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "menu-top-item": MenuTopItem,
    }
}
